import { UserOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/notice',
  component: Layout,
  name: 'NoticeParent',
  meta: { title: 'notice', root: true, auth: AUTH_KEYS.NOTICE },
  children: [
    {
      path: '',
      name: 'Notice',
      component: () => import('@/views/Notice.vue'),
      meta: {
        title: 'notice',
        isHide: true
      }
    }
  ]
};
